import * as React from 'react';
import type { WrapPageElementBrowserArgs } from 'gatsby';
import Layout from './src/components/Layout';

export function wrapPageElement({
  element,
  props,
}: WrapPageElementBrowserArgs) {
  return <Layout {...props}>{element}</Layout>;
}
